/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-11 15:49:18
 *
 *******************************************************/
//@flow
import _ from 'lodash';

import React, { Component } from 'react';
import { Banner } from '@shopify/polaris';

import { createMarkup, getFirstCharacter } from 'src/helpers';
import history from 'src/routes/history';

type Props = {
  status: string,
  notification: Object,
  onDismiss: Function
};
// DONE
class Notification extends Component<Props> {
  render() {
    const { notification = {}, status } = this.props;
    const {
      id,
      title,
      content,
      contentHtml,
      action,
      actionLabel,
      secondaryAction,
      secondaryActionLabel,
      allowDismiss,
      cssClassName
    } = notification;

    const propAction = _.isEmpty(action) ? {} : { action: this.buildAction(action, actionLabel) };

    const propSecondaryAction = _.isEmpty(secondaryAction)
      ? {}
      : {
          secondaryAction: this.buildAction(secondaryAction, secondaryActionLabel)
        };

    return (
      <div className={cssClassName ? `notification ${cssClassName}` : 'notification'}>
        <Banner
          title={title}
          onDismiss={
            allowDismiss || allowDismiss === undefined ? this.onDismiss.bind(this, id) : ''
          }
          status={status}
          {...propAction}
          {...propSecondaryAction}>
          {content && <p dangerouslySetInnerHTML={createMarkup(content)}></p>}
          {contentHtml && <div>{contentHtml}</div>}
        </Banner>
      </div>
    );
  }

  onDismiss = (notificationId: string) => {
    this.props.onDismiss(notificationId);
  };

  buildAction(action, actionLabel) {
    if (_.isEmpty(action)) return {};

    if (action === 'beacon') {
      return {
        onAction: event => {
          event.preventDefault();
          window.Beacon('open');
        },
        content: actionLabel
      };
    }
    if (getFirstCharacter(action) === '/') {
      return {
        onAction: () => {
          history.push(action);
        },
        content: actionLabel
      };
    }

    return { url: action, content: actionLabel, external: true };
  }
}

export default Notification;
